import { Injectable } from '@angular/core';
@Injectable(
    { providedIn: 'root' }
)
export class RecapchaConfigService {
    recaptchaSiteKeyV3: string = '6LfRh1IeAAAAAHtWRke9B5YG-QTnu3HpBhzAckg0';

    constructor() { }
}
